/**
 * IMBRIUM Gallery — Unified gallery with thumbnail strip + lightbox.
 * Merges inline <figure> elements and .im-image-gallery grid into one widget.
 * Mobile-first: swipe to navigate, tap backdrop to close.
 * Keyboard: Left/Right arrows, Escape to close.
 *
 * Hero exclusion: first <figure> in article content is standalone.
 * Gallery starts from the second <figure> onward.
 */
document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('.imbrium-article__content');
  if (!content) return;

  var allFigures = content.querySelectorAll('figure');
  var gridSection = content.querySelector('.im-image-gallery');

  /* Need at least hero + 1 gallery image, or a grid gallery */
  if (allFigures.length < 2 && !gridSection) return;

  /* Skip first figure (hero) AND figures inside .im-image-gallery (handled below) */
  var inlineFigures = [];
  for (var i = 1; i < allFigures.length; i++) {
    if (!allFigures[i].closest('.im-image-gallery')) {
      inlineFigures.push(allFigures[i]);
    }
  }

  /* Collect gallery items: { src, alt, caption, figure } */
  var items = [];

  /* Inline figures first */
  inlineFigures.forEach(function (fig) {
    var img = fig.querySelector('img');
    if (!img) return;
    var cap = fig.querySelector('figcaption');
    items.push({
      src: img.src,
      alt: img.alt || '',
      caption: cap ? cap.textContent.trim() : ''
    });
  });

  /* Grid gallery items (appended after inline) */
  if (gridSection) {
    gridSection.querySelectorAll('.im-gallery-item').forEach(function (fig) {
      var img = fig.querySelector('img');
      if (!img) return;
      var cap = fig.querySelector('figcaption');
      items.push({
        src: img.src,
        alt: img.alt || '',
        caption: cap ? cap.textContent.trim() : ''
      });
    });
  }

  if (!items.length) return;

  /* ================================================================
     INLINE GALLERY WIDGET — replaces scattered figures
     ================================================================ */
  var widget = document.createElement('div');
  widget.className = 'im-gallery';
  widget.setAttribute('aria-label', 'Photo gallery \u2014 ' + items.length + ' images');

  /* Main display image */
  var mainWrap = document.createElement('div');
  mainWrap.className = 'im-gallery__main';

  var mainImg = document.createElement('img');
  mainImg.className = 'im-gallery__main-img';
  mainImg.src = items[0].src;
  mainImg.alt = items[0].alt;
  mainImg.setAttribute('loading', 'lazy');

  var mainCaption = document.createElement('div');
  mainCaption.className = 'im-gallery__caption';
  mainCaption.textContent = items[0].caption;

  var mainCounter = document.createElement('span');
  mainCounter.className = 'im-gallery__counter';
  mainCounter.setAttribute('aria-live', 'polite');
  mainCounter.textContent = '1 / ' + items.length;

  /* Nav arrows for main image (desktop) */
  var mainPrev = document.createElement('button');
  mainPrev.className = 'im-gallery__nav im-gallery__nav--prev';
  mainPrev.setAttribute('aria-label', 'Previous image');
  mainPrev.innerHTML = '&#8249;';

  var mainNext = document.createElement('button');
  mainNext.className = 'im-gallery__nav im-gallery__nav--next';
  mainNext.setAttribute('aria-label', 'Next image');
  mainNext.innerHTML = '&#8250;';

  /* Expand hint */
  var expandHint = document.createElement('button');
  expandHint.className = 'im-gallery__expand';
  expandHint.setAttribute('aria-label', 'View fullscreen');
  expandHint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>';

  mainWrap.appendChild(mainImg);
  mainWrap.appendChild(mainCaption);
  mainWrap.appendChild(mainCounter);
  mainWrap.appendChild(mainPrev);
  mainWrap.appendChild(mainNext);
  mainWrap.appendChild(expandHint);

  /* Thumbnail strip */
  var thumbStrip = document.createElement('div');
  thumbStrip.className = 'im-gallery__thumbs';
  thumbStrip.setAttribute('role', 'tablist');
  thumbStrip.setAttribute('aria-label', 'Gallery thumbnails');

  items.forEach(function (item, idx) {
    var thumb = document.createElement('button');
    thumb.className = 'im-gallery__thumb' + (idx === 0 ? ' is-active' : '');
    thumb.setAttribute('role', 'tab');
    thumb.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
    thumb.setAttribute('aria-label', 'View image ' + (idx + 1) + (item.caption ? ': ' + item.caption : ''));

    var thumbImg = document.createElement('img');
    /* Use smaller src for thumbnails if possible — append Shopify width param */
    thumbImg.src = item.src.indexOf('?') > -1
      ? item.src.replace(/&?width=\d+/, '') + '&width=150'
      : item.src + '?width=150';
    thumbImg.alt = '';
    thumbImg.setAttribute('loading', 'lazy');
    thumbImg.setAttribute('aria-hidden', 'true');
    thumbImg.draggable = false;

    thumb.appendChild(thumbImg);
    thumbStrip.appendChild(thumb);
  });

  widget.appendChild(mainWrap);
  widget.appendChild(thumbStrip);

  /* Insert widget: at grid gallery position if it exists, else at first inline figure */
  if (gridSection) {
    gridSection.parentNode.insertBefore(widget, gridSection);
    gridSection.parentNode.removeChild(gridSection);
  } else if (inlineFigures.length) {
    inlineFigures[0].parentNode.insertBefore(widget, inlineFigures[0]);
  }

  /* Remove inline figures from article flow */
  inlineFigures.forEach(function (fig) {
    if (fig.parentNode) fig.parentNode.removeChild(fig);
  });

  /* ================================================================
     INLINE GALLERY STATE
     ================================================================ */
  var currentInline = 0;
  var thumbButtons = thumbStrip.querySelectorAll('.im-gallery__thumb');

  function showInline(index) {
    currentInline = ((index % items.length) + items.length) % items.length;
    var item = items[currentInline];

    mainImg.src = item.src;
    mainImg.alt = item.alt;
    mainCaption.textContent = item.caption;
    mainCounter.textContent = (currentInline + 1) + ' / ' + items.length;

    for (var t = 0; t < thumbButtons.length; t++) {
      var isActive = t === currentInline;
      thumbButtons[t].classList.toggle('is-active', isActive);
      thumbButtons[t].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    /* Scroll active thumb into view */
    thumbButtons[currentInline].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  /* Thumbnail clicks */
  thumbButtons.forEach(function (btn, idx) {
    btn.addEventListener('click', function () { showInline(idx); });
  });

  /* Main nav arrows */
  mainPrev.addEventListener('click', function (e) {
    e.stopPropagation();
    showInline(currentInline - 1);
  });
  mainNext.addEventListener('click', function (e) {
    e.stopPropagation();
    showInline(currentInline + 1);
  });

  /* Touch swipe on main image (mobile nav) */
  var mainTouchStartX = 0;
  var mainTouchStartY = 0;
  var mainSwiping = false;

  mainWrap.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) {
      mainTouchStartX = e.touches[0].clientX;
      mainTouchStartY = e.touches[0].clientY;
      mainSwiping = true;
    }
  }, { passive: true });

  mainWrap.addEventListener('touchend', function (e) {
    if (!mainSwiping) return;
    mainSwiping = false;
    var dx = e.changedTouches[0].clientX - mainTouchStartX;
    var dy = e.changedTouches[0].clientY - mainTouchStartY;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
    if (dx < 0) showInline(currentInline + 1);
    else showInline(currentInline - 1);
  }, { passive: true });

  /* ================================================================
     LIGHTBOX (fullscreen mode)
     ================================================================ */
  var overlay = document.createElement('div');
  overlay.className = 'im-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-label', 'Image gallery');
  overlay.setAttribute('aria-modal', 'true');
  overlay.innerHTML =
    '<button class="im-lightbox__close" aria-label="Close gallery">&times;</button>' +
    '<span class="im-lightbox__counter" aria-live="polite"></span>' +
    '<button class="im-lightbox__prev" aria-label="Previous image">&#8249;</button>' +
    '<button class="im-lightbox__next" aria-label="Next image">&#8250;</button>' +
    '<div class="im-lightbox__img-wrap">' +
      '<img class="im-lightbox__img" src="" alt="" />' +
      '<div class="im-lightbox__caption"></div>' +
    '</div>';
  document.body.appendChild(overlay);

  var lbImg = overlay.querySelector('.im-lightbox__img');
  var lbCaption = overlay.querySelector('.im-lightbox__caption');
  var lbCounter = overlay.querySelector('.im-lightbox__counter');
  var lbClose = overlay.querySelector('.im-lightbox__close');
  var lbPrev = overlay.querySelector('.im-lightbox__prev');
  var lbNext = overlay.querySelector('.im-lightbox__next');
  var lbWrap = overlay.querySelector('.im-lightbox__img-wrap');

  var currentLb = 0;
  var lbOpen = false;

  /* ================================================================
     LIGHTBOX ZOOM / PAN STATE
     ================================================================ */
  var zoom = 1, panX = 0, panY = 0;
  var MIN_ZOOM = 1, MAX_ZOOM = 4, DBL_ZOOM = 2;
  var lastInteractTime = 0;

  function applyTransform() {
    lbImg.style.transform = zoom <= 1.01
      ? ''
      : 'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
    var isZoomed = zoom > 1.05;
    lbWrap.classList.toggle('is-zoomed', isZoomed);
    overlay.classList.toggle('is-zoomed', isZoomed);
  }

  function resetZoom() {
    zoom = 1; panX = 0; panY = 0;
    applyTransform();
  }

  function clampPan() {
    if (zoom <= 1) { panX = 0; panY = 0; return; }
    var w = lbImg.offsetWidth * zoom;
    var h = lbImg.offsetHeight * zoom;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var maxX = Math.max(0, (w - vw) / 2);
    var maxY = Math.max(0, (h - vh) / 2);
    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
  }

  function zoomTo(newZoom, cx, cy) {
    newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, newZoom));
    if (Math.abs(newZoom - zoom) < 0.01) return;
    var rect = lbImg.getBoundingClientRect();
    var layoutCX = rect.left + rect.width / 2 - panX;
    var layoutCY = rect.top + rect.height / 2 - panY;
    var dx = cx - layoutCX;
    var dy = cy - layoutCY;
    var f = newZoom / zoom;
    panX = dx * (1 - f) + panX * f;
    panY = dy * (1 - f) + panY * f;
    zoom = newZoom;
    clampPan();
    applyTransform();
  }

  function showLb(index) {
    resetZoom();
    currentLb = ((index % items.length) + items.length) % items.length;
    var item = items[currentLb];
    lbImg.classList.add('is-loading');
    lbImg.src = item.src;
    lbImg.alt = item.alt;
    lbCaption.textContent = item.caption;
    lbCounter.textContent = (currentLb + 1) + ' / ' + items.length;

    if (lbImg.complete) {
      lbImg.classList.remove('is-loading');
    } else {
      lbImg.onload = function () { lbImg.classList.remove('is-loading'); };
    }
  }

  function openLb(index) {
    showLb(index);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lbOpen = true;
    lbClose.focus();
  }

  function closeLb() {
    resetZoom();
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    lbOpen = false;
    /* Sync inline gallery to lightbox position */
    showInline(currentLb);
  }

  /* Open lightbox from main image or expand button */
  mainImg.addEventListener('click', function () { openLb(currentInline); });
  expandHint.addEventListener('click', function (e) {
    e.stopPropagation();
    openLb(currentInline);
  });

  /* Lightbox navigation */
  lbClose.addEventListener('click', closeLb);
  lbPrev.addEventListener('click', function () { showLb(currentLb - 1); });
  lbNext.addEventListener('click', function () { showLb(currentLb + 1); });

  overlay.addEventListener('click', function (e) {
    if (Date.now() - lastInteractTime < 300) return;
    if (e.target === overlay || e.target === lbWrap) {
      if (zoom > 1.05) { resetZoom(); return; }
      closeLb();
    }
  });

  /* Keyboard */
  document.addEventListener('keydown', function (e) {
    if (!lbOpen) return;
    if (e.key === 'Escape') closeLb();
    else if (e.key === 'ArrowLeft') showLb(currentLb - 1);
    else if (e.key === 'ArrowRight') showLb(currentLb + 1);
  });

  /* ================================================================
     DESKTOP ZOOM INTERACTIONS
     ================================================================ */

  /* Wheel zoom */
  lbWrap.addEventListener('wheel', function (e) {
    if (!lbOpen) return;
    e.preventDefault();
    var factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
    zoomTo(zoom * factor, e.clientX, e.clientY);
  }, { passive: false });

  /* Single-click to toggle zoom — desktop only (matches cursor: zoom-in hint).
     On touch devices the click event fires after tap; skip it so double-tap
     and pinch remain the only mobile zoom gestures. */
  var clickZoomTimer = null;
  var lastTouchTime = 0;

  lbImg.addEventListener('click', function (e) {
    if (Date.now() - lastTouchTime < 500) return; /* touch-originated click */
    if (Date.now() - lastInteractTime < 300) return; /* skip after drag */
    if (clickZoomTimer) return; /* debounce — double-click pending */
    var cx = e.clientX, cy = e.clientY;
    clickZoomTimer = setTimeout(function () {
      clickZoomTimer = null;
      if (zoom > 1.05) resetZoom();
      else zoomTo(DBL_ZOOM, cx, cy);
    }, 220);
  });

  /* Double-click to toggle zoom (instant, cancels single-click delay) */
  lbImg.addEventListener('dblclick', function (e) {
    e.preventDefault();
    if (clickZoomTimer) { clearTimeout(clickZoomTimer); clickZoomTimer = null; }
    if (zoom > 1.05) resetZoom();
    else zoomTo(DBL_ZOOM, e.clientX, e.clientY);
  });

  /* Drag to pan when zoomed */
  var dragStartX = 0, dragStartY = 0;
  var dragPanX = 0, dragPanY = 0;
  var isDragging = false;
  var dragMoved = false;

  lbImg.addEventListener('mousedown', function (e) {
    if (zoom <= 1.05 || e.button !== 0) return;
    e.preventDefault();
    isDragging = true;
    dragMoved = false;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragPanX = panX;
    dragPanY = panY;
    lbWrap.classList.add('is-grabbing');
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) dragMoved = true;
    panX = dragPanX + dx;
    panY = dragPanY + dy;
    clampPan();
    applyTransform();
  });

  document.addEventListener('mouseup', function () {
    if (!isDragging) return;
    isDragging = false;
    if (dragMoved) lastInteractTime = Date.now();
    lbWrap.classList.remove('is-grabbing');
  });

  /* ================================================================
     MOBILE TOUCH: unified swipe / pan / pinch / double-tap
     ================================================================ */
  var touchMode = '';
  var touchStartX = 0, touchStartY = 0;
  var touchPanX = 0, touchPanY = 0;
  var pinchDist0 = 0, pinchZoom0 = 1, pinchCX = 0, pinchCY = 0;
  var lastTapTime = 0, lastTapX = 0, lastTapY = 0;

  function fingerDist(a, b) {
    var dx = b.clientX - a.clientX, dy = b.clientY - a.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  lbWrap.addEventListener('touchstart', function (e) {
    lastTouchTime = Date.now();
    if (e.touches.length === 2) {
      touchMode = 'pinch';
      pinchDist0 = fingerDist(e.touches[0], e.touches[1]);
      pinchZoom0 = zoom;
      pinchCX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      pinchCY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
    } else if (e.touches.length === 1) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      if (zoom > 1.05) {
        touchMode = 'pan';
        touchPanX = panX;
        touchPanY = panY;
      } else {
        touchMode = 'swipe';
      }
    }
  }, { passive: true });

  lbWrap.addEventListener('touchmove', function (e) {
    if (touchMode === 'pinch' && e.touches.length === 2) {
      e.preventDefault();
      var dist = fingerDist(e.touches[0], e.touches[1]);
      var nz = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, pinchZoom0 * (dist / pinchDist0)));
      zoomTo(nz, pinchCX, pinchCY);
    } else if (touchMode === 'pan' && e.touches.length === 1) {
      e.preventDefault();
      panX = touchPanX + (e.touches[0].clientX - touchStartX);
      panY = touchPanY + (e.touches[0].clientY - touchStartY);
      clampPan();
      applyTransform();
    }
  }, { passive: false });

  lbWrap.addEventListener('touchend', function (e) {
    var mode = touchMode;
    touchMode = '';

    if (mode === 'pinch' || mode === 'pan') {
      lastInteractTime = Date.now();
      return;
    }

    /* Swipe navigation (only at 1x zoom) */
    if (mode === 'swipe' && e.changedTouches.length === 1) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) showLb(currentLb + 1);
        else showLb(currentLb - 1);
        return;
      }
    }

    /* Double-tap detection */
    if (e.changedTouches.length === 1) {
      var now = Date.now();
      var tx = e.changedTouches[0].clientX;
      var ty = e.changedTouches[0].clientY;
      if (now - lastTapTime < 300 &&
          Math.abs(tx - lastTapX) + Math.abs(ty - lastTapY) < 50) {
        if (zoom > 1.05) resetZoom();
        else zoomTo(DBL_ZOOM, tx, ty);
        lastTapTime = 0;
        return;
      }
      lastTapTime = now;
      lastTapX = tx;
      lastTapY = ty;
    }
  }, { passive: true });
});
